enum RequestLogAction {
  RequestCreated = "RequestCreated",
  RequestUpdated = "RequestUpdated",
  RequestOpened = "RequestOpened",
  RequestClosed = "RequestClosed",
  CommentAdded = "CommentAdded"
}

export default RequestLogAction;
